//  [REDUCER][TYPE]
import { typeCreatorV2 } from '../../utils/common';

export const SET_FCM_TOKEN = typeCreatorV2('FCMReducer', 'SetFCMToken');
